import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../Selectors/MultiSelect";
import { campaign_names_in_range } from "../../../api_calls/campaignRequests";
import { updateStateData } from "../../../Store/actions";

const CampaignNameFilter = ({ vizId, fieldName, usedFor }) => {
  const campaignDetails = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [changesMade, setChangesMade] = React.useState(false);
  const [campaignSelection, setCampaignSelection] = React.useState([]);
  const [campaignNameOptionSelected, setCampaignNameOptionsSelected] = React.useState([]);

  React.useEffect(() => {
    const allCampaignNames = campaign_names_in_range();
    setCampaignNameOptionsSelected(allCampaignNames);
    dispatchAction(updateStateData({
      campaign_overview_selection: allCampaignNames.map(cmpgn => {
        return cmpgn.id
      }),
    }))
  }, []);

  return (
    <MultiSelect
      enableFullWidth={false}
      label={"Campaign Name"}
      options={campaign_names_in_range()}
      defaultVal={campaignNameOptionSelected}
      selectionCheck={(option, value) => option.label === value.label}
      usedFor="campaignNameFilter"
      onChangeCall={(selectedOption) => {
        let userChoices = [];
        setChangesMade(true);
        selectedOption.forEach((chosen) => {
          if (chosen.label !== "(All)") {
            userChoices.push(chosen.id);
          } else {
            userChoices.push([...new Set(campaignDetails.campaign_list.campaign_name_obj)]);
          }
        });
        setCampaignSelection(userChoices);
        setCampaignNameOptionsSelected(selectedOption);
      }}
      onBlurCall={(e) => {
        if (campaignSelection.length !== 0 && changesMade === true) {
          dispatchAction(updateStateData({
            campaign_overview_selection: campaignSelection
          }))
          setChangesMade(false);
        }
      }}
    />
  );
};

export default CampaignNameFilter;
